<template>
  <div>
    <header id="masthead" class="registration">
      <div class="wp1200">
         <router-link :to="{ name: 'home' }">
          <a class="logo"></a>
        </router-link>
      </div>
    </header>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration passReset two flex">
          <div class="col1_2">
            <img src="@/assets/images/mailOnWay.svg" />
          </div>
          <div class="col1_2 text flex align-content-center">
            <span class="check">
              <strong>{{ $t("login.text1") }}</strong>
              <span class="normal">{{ $t("login.text2") }}</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name:"ResetPasswordLinkSent"
};
</script>